import { BaseParentControlDrawer } from '../../core/abstraction/BaseParentControlDrawer';
import { GAME_MODES } from '../../core/constats';
import { GAME_MODE } from '../../stateManagment/gameState';

import { WheelMobileDrawer } from './drawers/WheelMobileDrawer';
import { WheelDesktopDrawer } from './drawers/WheelDesktopDrawer';

export class WheelDrawer extends BaseParentControlDrawer {
  execute(mode, config = {}) {
    return super.execute(mode, config);
  }

  rotate() {
    this.getGoodLuckAnimation();
    return new Promise(resolve => {
      this.applications[GAME_MODE.getValue()].rotate(resolve);
    })
  }

  winAnimation(data) {
    this.applications[GAME_MODE.getValue()].winAnimation(data);
  }

  bonusWinAnimation(data) {
    this.applications[GAME_MODE.getValue()].bonusWinAnimation(data);
  }

  resetWheelCrystals() {
    this.application.resetWheelCrystals();
  }

  screenTransaction(...arg) {
    this.applications[GAME_MODE.getValue()].screenTransaction(...arg);
  }

  getGoodLuckAnimation(...arg) {
    this.applications[GAME_MODE.getValue()].getGoodLuckAnimation(...arg);
  }

  get wheel() {
    return this.application.circle.children[1];
  }

  get container() {
    return this.application.container;
  }

  get containerAndWheel() {
    return [
      this.wheel,
      this.container,
    ];
  }
}

export const wheelDrawer = new WheelDrawer({
  [GAME_MODES.MOBILE]: new WheelMobileDrawer(),
  [GAME_MODES.MOBILE_LANDSCAPE]: new WheelMobileDrawer(),
  [GAME_MODES.DESKTOP]: new WheelDesktopDrawer(),
});

export const bonusWheelDrawer = new WheelDrawer({
  [GAME_MODES.MOBILE]: new WheelMobileDrawer(),
  [GAME_MODES.DESKTOP]: new WheelDesktopDrawer(),
});
